<template>
    <div v-loading="loading" id="settle-detail">
        <div>
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="drawerList"
                row-key="id"
                default-expand-all
                style="width: 100%"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
                <el-table-column fixed="right" label="操作" width="135px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button
                                v-if="permission.confirmApply && !scope.row.IsConfirm"
                                :title="permission.confirmApply"
                                size="mini"
                                type="text"
                                :style="scope.row.PRType == 3 ? btnOrStyle : ''"
                                @click="confirmApply(scope.row.RecordId)"
                                >{{ scope.row.PRType == 0 || scope.row.PRType == 4 || (scope.row.PRType == 9 && scope.row.SumPayable > 0) ? '确认收款' : '确认付款' }}</el-button
                            >
                            <el-button
                                v-if="permission.cancelApply && !scope.row.IsConfirm"
                                :title="permission.cancelApply"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="cancelApply(scope.row.RecordId)"
                                >{{ permission.cancelApply }}</el-button
                            >
                            <el-button v-if="scope.row.IsConfirm && scope.row.PRType != 8" size="mini" type="text" disabled>{{
                                scope.row.PRType == 0 || scope.row.PRType == 4 || (scope.row.PRType == 9 && scope.row.SumPayable > 0) ? '已确认收款' : '已确认付款'
                            }}</el-button>
                            <el-button
                                v-if="permission.settleUp && scope.row.PRType == 8 && !scope.row.IsSettle"
                                :title="permission.settleUp"
                                size="mini"
                                type="text"
                                :style="scope.row.SumPayable > 0 ? btnOrStyle2 : ''"
                                @click="settleUp(scope.row)"
                                >{{ scope.row.SumPayable > 0 ? '核算收款' : '核算付款' }}</el-button
                            >
                            <el-button
                                v-if="permission.settleUpNeedConfirm && scope.row.PRType == 8 && !scope.row.IsSettle"
                                :title="permission.settleUpNeedConfirm"
                                size="mini"
                                type="text"
                                @click="settleUpNeedConfirm(scope.row.RecordId, scope.row.SumPayable, scope.row.CName, scope.row.AlreadyPaid)"
                                >{{ scope.row.SumPayable > 0 ? '申请核收' : '申请核付' }}</el-button
                            >
                            <el-button
                                v-if="permission.backState && scope.row.IsCanBack && scope.row.IsConfirm && scope.row.PRType != 8"
                                size="mini"
                                type="text"
                                style="margin-left: 8px; color: red"
                                @click="backState(scope.row.RecordId)"
                                >{{ permission.backState }}</el-button
                            >
                            <el-button
                                v-if="permission.backState && scope.row.IsSettle && scope.row.IsConfirm && scope.row.PRType == 8"
                                size="mini"
                                type="text"
                                style="margin-left: 8px; color: red"
                                @click="backState(scope.row.RecordId)"
                                >{{ permission.backState }}</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="RecordCode" label="流水号" width="220" />
                <el-table-column prop="PRTypeName" label="款项类型" width="120" />
                <el-table-column prop="PayTypeName" label="支付方式" />
                <el-table-column prop="SumPayable" label="应收/应付总额" width="120" />
                <el-table-column prop="AlreadyPaid" label="已付/收款" width="100" />
                <el-table-column prop="NowPay" label="本次付/收款" width="120" />
                <el-table-column prop="Balance" label="余额" width="80">
                    <template slot-scope="scope">
                        {{
                            scope.row.PRType == 8 && scope.row.IsSettle
                                ? 0
                                : scope.row.PRType == 5
                                ? scope.row.IsSettle
                                    ? 0
                                    : scope.row.AlreadyPaid
                                : (Math.abs(scope.row.SumPayable) + scope.row.ShipMoney - Math.abs(scope.row.AlreadyPaid) - scope.row.NowPay).toFixed(2)
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="Discount" label="减收/付">
                    <template slot-scope="scope">
                        {{
                            scope.row.PRType == 8 && scope.row.IsSettle
                                ? (Math.abs(scope.row.SumPayable) + scope.row.ShipMoney - Math.abs(scope.row.AlreadyPaid) - scope.row.NowPay).toFixed(2)
                                : 0
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" />
                <el-table-column prop="CreateTime" label="申请时间" width="150" />
                <el-table-column prop="PayTime" label="确认时间" width="150" />
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" :title="'【' + EntpCusName + '】核算结款'" :visible.sync="dialogSettleUpVisible" width="1200px" append-to-body>
            <div class="dialog-content" v-if="dialogSettleUpVisible">
                <SettleUp ref="settleUp" @closeSettleUp="closeSettleUp" :RecordId="RecordId" :Amount="Amount" :Type="0" :Paid="Paid"></SettleUp>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :title="'【' + EntpCusName + '】申请结算款项'"
            :visible.sync="dialogNewSettleUpVisible"
            width="1200px"
            append-to-body
            @close="closeUpNeedDialog"
        >
            <div class="dialog-content" v-if="dialogNewSettleUpVisible">
                <SettleUpNeedConfirm ref="settleUpNeedConfirm" @closeSettleUp="closeSettleUp" :RecordId="RecordId" :Amount="Amount" :Type="0" :Paid="Paid"></SettleUpNeedConfirm>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import SettleUp from '@/components/business/revenue/settleUp';
import SettleUpNeedConfirm from '@/components/business/revenue/settleUpNeedConfirm';
export default {
    name: '',
    props: ['SettleId'],
    components: { SettleUp, SettleUpNeedConfirm },
    data() {
        return {
            loading: false,
            drawerList: [],
            permission: [],
            btnOrStyle: 'color:orange',
            btnOrStyle2: 'color:red',
            dialogSettleUpVisible: false,
            dialogNewSettleUpVisible: false,
            RecordId: '',
            EntpCusName: '',
            Amount: 0,
            Paid: 0,
            settleId: ''
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('Settlement');
        if (this.SettleId) {
            this.settleId = this.SettleId;
            this.getTableData();
        }
        // 打开时禁止页面滚动
        document.body.style = 'overflow:hidden';
    },
    destroyed() {
        document.body.style = 'overflow:auto';
    },
    methods: {
        // 更新表格数据
        updateTableData(id) {
            this.settleId = id;
            this.getTableData();
        },
        getTableData() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetReceiptRecordsListBySId',
                    data: {
                        SId: this.settleId
                    }
                })
                .then(res => {
                    if (res.errcode === 0) {
                        if (res.data) {
                            this.drawerList = res.data;
                        }
                    }
                    that.loading = false;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        closeSettleUp(eidt) {
            this.dialogSettleUpVisible = false;
            this.dialogNewSettleUpVisible = false;
            if (eidt) this.getTableData();
        },
        closeUpNeedDialog() {
            this.closeSettleUp(true);
        },
        settleUp(item) {
            if (item) {
                this.dialogSettleUpVisible = true;
                this.RecordId = item.RecordId;
                this.Amount = item.SumPayable;
                this.EntpCusName = item.CName;
                this.Paid = item.AlreadyPaid;
            } else {
                this.$util.warningMsg('需要结款的往来数据异常，请刷新后重试');
            }
        },
        settleUpNeedConfirm(id, amount, name, paid) {
            if (id) {
                this.dialogNewSettleUpVisible = true;
                this.RecordId = id;
                this.Amount = amount;
                this.EntpCusName = name;
                this.Paid = paid;
            } else {
                this.$util.warningMsg('需要结款的往来数据异常，请刷新后重试');
            }
        },
        confirmApply(id) {
            if (id) {
                this.$confirm('是否确认该条款项申请？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/ConfirmApplyRecords?RecordId=${id}`
                            })
                            .then(res => {
                                this.$util.successMsg('确认款项成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        },
        cancelApply(id) {
            if (id) {
                this.$confirm('是否要撤销该条款项申请，撤销后将无法恢复？', '提示', {
                    confirmButtonText: '确定撤销',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/CancelApplyRecords?RecordId=${id}`
                            })
                            .then(res => {
                                this.$util.successMsg('撤销申请成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择撤销有效申请款项');
            }
        },
        backState(id) {
            if (id) {
                this.$confirm('是否回退该条款项的确认状态？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/RevenueManagement/BackRecordStates?RecordId=${id}`
                            })
                            .then(res => {
                                this.$util.successMsg('回退状态成功');
                                this.getTableData();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效申请款项');
            }
        }
    }
};
</script>
<style lang="less">
#settle-detail {
    .el-table {
        margin-bottom: 0px;
    }
}
</style>
